import i18n from '@/localisation/i18n';
import { useUserStore } from '@/store/user';
import { HeaderInfo } from '@/UI/HeaderInfo';
import { Warning } from '@/UI/Warning';
import { motion } from 'framer-motion';
import { DashboardBanner } from './banners/DashboardBanner';
import { OurApp } from './banners/OurApp';
import { Link } from 'react-router-dom';
import { InstallAppBanner } from './banners/InstallAppBanner';

export const Dashboard = () => {
  const { img, name } = useUserStore();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      className="w-full"
    >
      <HeaderInfo title={i18n.t('main')} subtitle={i18n.t('main.subtitle')}>
        <div className="mb-4 mt-8 md:pr-4">
          {(!img || !name) && (
            <Link to="/profile">
              <Warning
                title={i18n.t('warning.profile.title')}
                subtitle={i18n.t('warning.profile.subtitle')}
              />
            </Link>
          )}
          <div className="mt-8 flex flex-col gap-6 xl:flex-row">
            <InstallAppBanner />
            <Link to="/new-client">
              <DashboardBanner
                title={i18n.t('banner.addClient.title')}
                subtitle={i18n.t('banner.addClient.subtitle')}
                img="/images/newClient.svg"
              />
            </Link>

            <OurApp />
          </div>
        </div>
      </HeaderInfo>
    </motion.div>
  );
};
